export class Permissions {
    canManagerUsers: boolean;
    canSeeAllOrganizations: boolean;  
    canDraftApplications: boolean;
    canProcessApplications: boolean;
    canChangeDispositionApplications: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/permissions.ts